import { FC } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { useTitle } from '../hooks/useTitle';

import ChannelCategoryConfig from 'src/components/Channel/ChannelCategoryConfig/ChannelCategoryConfig';
import ChannelList from 'src/components/Channel/ChannelList/ChannelList';
import ChatRoom from 'src/components/Channel/ChatRoom/ChatRoom';
import ComposeMessage from 'src/components/Channel/ComposeMessage/ComposeMessage';
import MessageHistory from 'src/components/Channel/MessageHistory/MessageHistory';

const ChannelPage: FC<{ title: string }> = ({ title }) => {
  useTitle(`GU 관리자 | ${title}`);
  return (
    <Routes>
      <Route path='/list' element={<ChannelList />} />
      <Route path='/compose' element={<ComposeMessage />} />
      <Route path='/chat' element={<ChatRoom />} />
      <Route path='/messages' element={<MessageHistory mode='broadcast' />} />
      <Route path='/chat-messages' element={<MessageHistory mode='conversation' />} />
      <Route path='/category-config' element={<ChannelCategoryConfig />} />
      <Route path='/' element={<Navigate to='/channel/list' replace />} />
    </Routes>
  );
};

export default ChannelPage;
